<nz-page-header nzTitle="用户管理">
  <!--  <nz-breadcrumb nz-page-header-breadcrumb>-->
  <!--    <nz-breadcrumb-item>首页</nz-breadcrumb-item>-->
  <!--    <nz-breadcrumb-item>用户管理</nz-breadcrumb-item>-->
  <!--  </nz-breadcrumb>-->
  <nz-page-header-footer>
    <nz-tabs [(nzSelectedIndex)]="currentTab" (nzSelectedIndexChange)="selectedTabChange($event)">
      <nz-tab nzTitle="学生账号"> </nz-tab>
      <nz-tab nzTitle="教师账号"> </nz-tab>
    </nz-tabs>
  </nz-page-header-footer>
</nz-page-header>

<div class="p-md">
  <nz-card>
    @if (currentTab === 0) {
      <!-- 学生账号搜索栏 -->
      <nz-row nzAlign="middle" [nzGutter]="12">
        @if (isStaffSite) {
          <nz-col nzXXl="2" nzMd="3">
            <nz-select
              class="w-full"
              [(ngModel)]="selectedSiteId"
              nzPlaceHolder="请选择站点"
              nzAllowClear
              nzShowSearch
              (ngModelChange)="onSiteChange($event)"
            >
              @for (site of siteList; track site.id) {
                <nz-option [nzValue]="site.id" [nzLabel]="site.siteTitle"></nz-option>
              }
            </nz-select>
          </nz-col>
        }
        <div nz-col nzXXl="2" nzMd="3">
          <nz-select
            style="width: 100%"
            [(ngModel)]="grade"
            (ngModelChange)="onSelectGrade($event)"
            nzPlaceHolder="请选择年级"
            nzAllowClear
          >
            @for (item of gradeList; track item) {
              <nz-option [nzLabel]="item.name" [nzValue]="item.id" nzCustomContent>
                <span nz-tooltip [nzTooltipTitle]="item.name">{{ item.name }}</span>
              </nz-option>
            }
          </nz-select>
        </div>
        <div nz-col nzXXl="2" nzMd="3">
          <nz-select
            style="width: 100%"
            [(ngModel)]="classroom"
            (ngModelChange)="onSelectClassroom($event)"
            nzPlaceHolder="请选择班级"
            nzAllowClear
          >
            @for (item of classroomList; track item) {
              <nz-option [nzLabel]="item.name" [nzValue]="item.id" nzCustomContent>
                <span nz-tooltip [nzTooltipTitle]="item.name">{{ item.name }}</span>
              </nz-option>
            }
          </nz-select>
        </div>
        <div nz-col nzXXl="2" nzMd="3">
          <nz-select
            style="width: 100%"
            [(ngModel)]="isActive"
            (ngModelChange)="onSelectActive($event)"
            nzPlaceHolder="请选择状态"
            nzAllowClear
          >
            <nz-option nzLabel="启用" [nzValue]="true"></nz-option>
            <nz-option nzLabel="禁用" [nzValue]="false"></nz-option>
          </nz-select>
        </div>
        <div nz-col nzXXl="4" nzMd="5" class="ml-sm">
          <input
            nz-input
            placeholder="请输入用户名、准考证号或姓名"
            (keydown.enter)="search()"
            [(ngModel)]="kw"
            style="width: 100%"
          />
        </div>
        <button nz-button [nzType]="'primary'" class="ml-sm" (click)="search()">
          <span>搜索</span>
        </button>
      </nz-row>
    } @else {
      <!-- 教师账号搜索栏 -->
      <nz-row nzAlign="middle" nzJustify="space-between" [nzGutter]="12">
        <div nz-col nzFlex="1" class="flex">
          @if (isStaffSite) {
            <nz-col nzXXl="2" nzMd="3">
              <nz-select
                class="w-full"
                [(ngModel)]="selectedSiteId"
                nzPlaceHolder="请选择站点"
                nzAllowClear
                nzShowSearch
                (ngModelChange)="onSiteChange($event)"
              >
                @for (site of siteList; track site.id) {
                  <nz-option [nzValue]="site.id" [nzLabel]="site.siteTitle"></nz-option>
                }
              </nz-select>
            </nz-col>
          }
          <div nz-col nzXXl="2" nzMd="3">
            <nz-select
              style="width: 100%"
              [(ngModel)]="grade"
              (ngModelChange)="onSelectGrade($event)"
              nzPlaceHolder="请选择年级"
              nzAllowClear
            >
              @for (item of gradeList; track item) {
                <nz-option [nzLabel]="item.name" [nzValue]="item.id"></nz-option>
              }
            </nz-select>
          </div>
          <div nz-col nzXXl="2" nzMd="3">
            <nz-select
              style="width: 100%"
              [(ngModel)]="subject"
              (ngModelChange)="onSelectSubject($event)"
              nzPlaceHolder="请选择学科"
              nzAllowClear
            >
              @for (item of subjectList; track item) {
                <nz-option [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
              }
            </nz-select>
          </div>
          <div nz-col nzXXl="2" nzMd="3">
            <nz-select
              style="width: 100%"
              [(ngModel)]="role"
              (ngModelChange)="onSelectRole($event)"
              nzPlaceHolder="请选择角色"
              nzAllowClear
            >
              <nz-option nzLabel="分站管理员" [nzValue]="1"></nz-option>
              <nz-option nzLabel="年级主任" [nzValue]="2"></nz-option>
              <nz-option nzLabel="学科组长" [nzValue]="3"></nz-option>
              <nz-option nzLabel="班主任" [nzValue]="4"></nz-option>
              <nz-option nzLabel="普通教师" [nzValue]="5"></nz-option>
            </nz-select>
          </div>
          <div nz-col nzXXl="2" nzMd="3">
            <nz-select
              style="width: 100%"
              [(ngModel)]="isActive"
              (ngModelChange)="onSelectActive($event)"
              nzPlaceHolder="请选择状态"
              nzAllowClear
            >
              <nz-option nzLabel="启用" [nzValue]="true"></nz-option>
              <nz-option nzLabel="禁用" [nzValue]="false"></nz-option>
            </nz-select>
          </div>
          <div nz-col nzXXl="3" nzMd="4" class="ml-sm">
            <input
              nz-input
              placeholder="请输入用户名或姓名"
              (keydown.enter)="search()"
              [(ngModel)]="kw"
              style="width: 100%"
            />
          </div>
          <button nz-button [nzType]="'primary'" class="ml-sm" (click)="search()">
            <span>搜索</span>
          </button>
        </div>
      </nz-row>
    }

    @if (loading && list.length === 0) {
      <nz-alert class="mt-md" nzType="warning" nzMessage="未找到相关用户,请更换搜索条件" nzShowIcon> </nz-alert>
    }

    @if (list.length > 0) {
      @if (currentTab === 0) {
        <nz-table
          #nzTable
          [nzLoading]="isTableLoading"
          [nzData]="list"
          [nzTotal]="total"
          [(nzPageIndex)]="page"
          [nzFrontPagination]="false"
          (nzPageIndexChange)="search($event)"
          [nzPageSize]="15"
          class="mt-md"
        >
          <thead>
            <tr>
              <th><span>序号</span></th>
              <th><span>姓名</span></th>
              @if (currentTab === 0) {
                <th><span>准考证号</span></th>
              }
              <th><span>用户名</span></th>
              @if (!currentTab) {
                <th><span>年级</span></th>
              }
              @if (!currentTab) {
                <th><span>班级</span></th>
              }
              @if (currentTab) {
                <th><span>任教科目</span></th>
              }
              @if (currentTab) {
                <th><span>任教年级</span></th>
              }
              @if (currentTab) {
                <th><span>角色</span></th>
              }
              <th><span>注册时间</span></th>
              <th><span>最后登录时间</span></th>
              <!-- <th><span>关联知识图谱</span></th> -->
              <th><span>状态</span></th>
              <th><span>操作</span></th>
            </tr>
          </thead>
          <tbody>
            @for (user of nzTable.data; track user; let index = $index) {
              <tr>
                <td>{{ (page - 1) * 15 + (index + 1) }}</td>
                <td>{{ user?.firstName }}</td>
                @if (currentTab === 0) {
                  <td>{{ user?.studentNo }}</td>
                }
                <td>{{ user?.userName }}</td>
                @if (currentTab) {
                  <td>{{ user?.subject }}</td>
                }
                <td>
                  <div
                    nz-tooltip
                    [nzTooltipTitle]="gradeTemplate"
                    style="
                      width: 100px;
                      overflow: hidden;
                      -ms-text-overflow: ellipsis;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    "
                  >
                    <!-- ManageUser.grade 声明为 string | string[]（接口可能返回单值），.join 依赖运行期数组数据 -->
                    {{ user?.grade.join('、') }}
                  </div>
                  <ng-template #gradeTemplate>
                    @for (item of user?.grade; track item) {
                      <div>{{ item }}</div>
                    }
                  </ng-template>
                </td>
                @if (!currentTab) {
                  <td>
                    <div
                      nz-tooltip
                      [nzTooltipTitle]="classroomTemplate"
                      style="
                        width: 100px;
                        overflow: hidden;
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                    >
                      {{ user?.classroom.join('、') }}
                    </div>
                    <ng-template #classroomTemplate>
                      @for (item of user?.classroom; track item) {
                        <div>{{ item }}</div>
                      }
                    </ng-template>
                  </td>
                }
                @if (currentTab) {
                  <td>
                    <div
                      nz-tooltip
                      [nzTooltipTitle]="roleTemplate"
                      style="
                        width: 100px;
                        overflow: hidden;
                        -ms-text-overflow: ellipsis;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                    >
                      {{ user?.role.join('、') }}
                    </div>
                    <ng-template #roleTemplate>
                      @for (role of user?.role; track role) {
                        <div>{{ role }}</div>
                      }
                    </ng-template>
                  </td>
                }
                <td>{{ user?.dateJoined }}</td>
                <td>{{ user?.lastLogin }}</td>
                <td>
                  @if (user?.isActive) {
                    <span>启用</span>
                  }
                  @if (!user?.isActive) {
                    <span>禁用</span>
                  }
                </td>
                @if (!user?.isStaff) {
                  <td>
                    <button flCheckLoginType nz-button nzType="link" (click)="onView(user)">编辑</button>
                    <button flCheckLoginType nz-button nzType="link" (click)="onUnBind(user)">解绑</button>
                  </td>
                }
                @if (user?.isStaff) {
                  <td class="text-primary point" flCheckLoginType (click)="onEdit(user)">编辑</td>
                }
              </tr>
            }
          </tbody>
        </nz-table>
      }

      @if (currentTab === 1) {
        <nz-table
          #nzTable
          [nzLoading]="isTableLoading"
          [nzData]="list"
          [nzTotal]="total"
          [(nzPageIndex)]="page"
          [nzFrontPagination]="false"
          (nzPageIndexChange)="search($event)"
          [nzPageSize]="15"
          class="mt-md"
        >
          <thead>
            <tr>
              <th
                [nzShowCheckbox]="true"
                [(nzChecked)]="checked"
                [nzIndeterminate]="indeterminate"
                (nzCheckedChange)="onCheckAll()"
                nzWidth="50px"
              ></th>
              <th>教师</th>
              <th>角色 / 任教年级</th>
              <th>最后登录时间 / 注册时间</th>
              <th>账号状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            @for (user of nzTable.data; track user; let index = $index) {
              <tr>
                <td [nzShowCheckbox]="true" [(nzChecked)]="user.checked" (nzCheckedChange)="onItemChecked(user)"></td>
                <td>
                  <div class="flex">
                    <img
                      class="w-[40px] h-[40px]"
                      [src]="user.avatar === '' || !user.avatar ? sharedSrv.AvatarUrl : user.avatar"
                      alt=""
                    />
                    <div class="ml-3">
                      <p class="text-neutral-n1 font-medium">{{ user.firstName }} {{ user?.subject }}</p>
                      <p class="text-neutral-n2">{{ user.userName | maskAccount }}</p>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    class="w-[200px] truncate text-neutral-n1 font-medium"
                    nz-tooltip
                    [nzTooltipTitle]="gradeTemplate"
                  >
                    {{ user?.grade.join('、') }}
                  </div>
                  <ng-template #gradeTemplate>
                    @for (item of user?.grade; track item) {
                      <div>{{ item }}</div>
                    }
                  </ng-template>
                  <div nz-tooltip [nzTooltipTitle]="roleTemplate" class="w-[200px] truncate text-neutral-n2">
                    {{ user?.role.join('、') }}
                  </div>
                  <ng-template #roleTemplate>
                    @for (role of user?.role; track role) {
                      <div>{{ role }}</div>
                    }
                  </ng-template>
                </td>
                <td>
                  <p class="text-neutral-n1 font-medium">
                    {{ user?.lastLogin | date: 'yyyy/MM/dd HH:mm' }}
                  </p>
                  <p class="text-neutral-n2">
                    {{ user?.dateJoined | date: 'yy/MM/dd' }} 注册
                  </p>
                </td>
                <td>
                  <span [class.text-red-r1]="!user.isActive">{{ user?.isActive ? '正常' : '禁用' }}</span>
                </td>
                <td class="text-primary point" flCheckLoginType (click)="onEdit(user)">编辑</td>
              </tr>
            }
          </tbody>
        </nz-table>
      }
    }

    <!--查看学生信息-->
    <nz-modal
      [(nzVisible)]="stdEditSetting.show"
      nzTitle="编辑用户信息"
      [nzOkLoading]="stdEditSetting.loading"
      (nzOnCancel)="stdEditSetting.show = false"
      (nzOnOk)="editStd()"
    >
      <ng-container *nzModalContent>
        <form nz-form [formGroup]="viewUserForm">
          <!--账号-->
          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">账号</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              <label>{{ currentUser?.username }}</label>
            </nz-form-control>
          </nz-form-item>
          <!--真实姓名-->
          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6" nzRequired>真实姓名</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              <input nz-input [nzSize]="'large'" formControlName="firstName" />
              @if (viewUserForm.controls['firstName'].hasError('required')) {
                <!-- nz-form-explain 已从 ng-zorro 移除（新版本用 nz-form-control 的 nzErrorTip 替代）；
                     改用 div 保留原红字提示，显示条件与文案不变 -->
                <div class="text-red"> 真实姓名不能为空 </div>
              }
            </nz-form-control>
          </nz-form-item>
          <!--准考证号-->
          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">准考证号</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              <input nz-input [nzSize]="'large'" formControlName="studentNo" placeholder="请输入4~12位数字" />
              @if (viewUserForm.controls['studentNo'].hasError('pattern')) {
                <div class="text-red"> 请输入4~12位纯数字 </div>
              }
            </nz-form-control>
          </nz-form-item>
          <!--新密码-->
          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">密码</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              <label>*******</label>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">所在年级</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              @for (grade of currentUser?.grade; track grade) {
                <div>{{ grade }}</div>
              }
            </nz-form-control>
          </nz-form-item>

          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">所在班级</nz-form-label>
            <nz-form-control nz-col [nzSm]="14">
              @for (classroom of currentUser?.classroom; track classroom) {
                <div>{{ classroom.name }}</div>
              }
            </nz-form-control>
          </nz-form-item>

          <!--禁用-->
          <nz-form-item nz-row>
            <nz-form-label nz-col [nzSm]="6">启用</nz-form-label>
            <nz-form-control nz-col [nzSpan]="14">
              <nz-switch formControlName="isActive" [ngModel]="viewUserForm.get('isActive').value">
                <span checked>开</span>
                <span unchecked>关</span>
              </nz-switch>
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-container>
    </nz-modal>
    <!--编辑用户信息-->
    <ng-template #edit>
      <form nz-form [formGroup]="editUserForm">
        <!--账号-->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">账号</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            <label>{{ currentUser?.username }}</label>
          </nz-form-control>
        </nz-form-item>
        <!--真实姓名-->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6" nzRequired>真实姓名</nz-form-label>
          <nz-form-control nz-col [nzSm]="14" nzHasFeedback [nzErrorTip]="firstnameEditTpl">
            <input nz-input [nzSize]="'large'" formControlName="firstName" />
            <ng-template #firstnameEditTpl let-control>
              @if (editUserForm.controls['firstName'].hasError('required')) {
                <ng-container class="text-red"> 真实姓名不能为空 </ng-container>
              }
              @if (editUserForm.controls['firstName'].hasError('pattern')) {
                <ng-container class="text-red"> 真实姓名不合法,请输入2-6个中文字符 </ng-container>
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
        <!--新密码-->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">密码</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            <span>*******</span>
          </nz-form-control>
        </nz-form-item>

        <!-- 教师权限 -->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">教师权限</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            <nz-select formControlName="role" nzPlaceHolder="请选择教师权限">
              <nz-option nzLabel="分站管理员" [nzValue]="1"></nz-option>
              <nz-option nzLabel="年级主任" [nzValue]="2"></nz-option>
              <nz-option nzLabel="学科组长" [nzValue]="3"></nz-option>
              <nz-option nzLabel="普通教师" [nzValue]="4"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <!-- 任教科目 -->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">任教科目</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            <nz-select formControlName="subject" nzPlaceHolder="请选择任教科目">
              @for (subject of subjectList; track subject) {
                <nz-option [nzLabel]="subject.name" [nzValue]="subject.id"> </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <!-- 任教科目 -->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">任教年级</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            @for (item of currentUser.grade; track item) {
              <div>{{ item }}</div>
            }
          </nz-form-control>
        </nz-form-item>

        <!-- 任教班级 -->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">任教班级</nz-form-label>
          <nz-form-control nz-col [nzSm]="14">
            @for (item of currentUser.classroom; track item) {
              <div>{{ item }}</div>
            }
          </nz-form-control>
        </nz-form-item>

        <!--关联知识图谱权限-->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">关联知识图谱</nz-form-label>
          <nz-form-control nz-col [nzSpan]="14">
            <nz-switch
              formControlName="questionAssociateNode"
              [ngModel]="editUserForm.get('questionAssociateNode').value"
            >
              <span checked>开</span>
              <span unchecked>关</span>
            </nz-switch>
          </nz-form-control>
        </nz-form-item>

        <!--禁用-->
        <nz-form-item nz-row>
          <nz-form-label nz-col [nzSm]="6">启用</nz-form-label>
          <nz-form-control nz-col [nzSpan]="14">
            <nz-switch formControlName="isActive" [ngModel]="editUserForm.get('isActive').value">
              <span checked>开</span>
              <span unchecked>关</span>
            </nz-switch>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-template>
  </nz-card>
</div>
